<template>
  <div>
    <router-view />
  </div>
</template>

<script>
import { socket, connect } from "@/socket";
import { toast } from "vue3-toastify";
import pingSound from "@/assets/audio/ping_sound.mp3";

export default {
  data() {
    return {
      userId: null,
      audio: null,
      audioUnlocked: false,
    };
  },

  mounted() {
    // Create reusable audio instance
    this.audio = new Audio(pingSound);

    // Unlock audio after first user interaction (browser policy)
    window.addEventListener(
      "click",
      () => {
        this.audioUnlocked = true;
      },
      { once: true }
    );

    // Get user from store
    const storedUserId = this.$store?.state?.user?.id;

    if (storedUserId) {
      this.userId = storedUserId;

      // Connect socket
      connect(this.userId);

      // Prevent duplicate listeners
      socket.off("ping");
      socket.off("connect");
      socket.off("disconnect");

      // Global listener for pings
      socket.on("ping", (data) => {
        toast.success(`${data.message}`, {
          autoClose: 10000,
          hideProgressBar: false,
          position: "top-right",
          pauseOnHover: true,
          draggable: true,
        });

        this.playPingSound();
      });

      // Handle reconnect automatically
      socket.on("connect", () => {
        console.log("Socket connected:", socket.id);

        if (this.userId) {
          socket.emit("join", this.userId);
          console.log("Re-joined room for user:", this.userId);
        }
      });

      // Optional: handle disconnect
      socket.on("disconnect", (reason) => {
        console.warn("Socket disconnected:", reason);
      });
    }
  },

  methods: {
    playPingSound() {
      if (!this.audioUnlocked || !this.audio) return;

      try {
        this.audio.currentTime = 0;
        this.audio.play().catch(() => {});
      } catch (error) {
        console.warn("Audio play failed:", error);
      }
    },
  },
};
</script>

<style></style>